import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table } from 'antd';
import ApiService from '../../../../../services/ApiService';
import DataService from '../../../../../services/DataService';
import { useSimulationContext } from '../../../../../contexts/SimulationContext';

const getMigrationTableColumns = setSelectedResourceId => {
  const countryList = DataService.getItem('countryList');
  const resourceList = DataService.getItem('resourceList');

  const columns = [
    {
      id: 'year',
      title: 'Year',
      dataIndex: 'simulationYearIndex',
    },
    {
      id: 'laborType',
      title: 'Labor Type',
      render: row => {
        const resource = resourceList.find(r => r.resourceId === row.resourceId);
        const iconName = resource.iconUrl.split('/').pop();
        const iconUrl = `/images/icons/resources/${iconName}`;
        return (
          <div className="resource-link" onClick={() => setSelectedResourceId(row.resourceId)}>
            <img width={20} src={iconUrl} alt={resource.resourceNameLocalized} />
            <span style={{ paddingLeft: 8 }}>{resource.resourceNameLocalized}</span>
          </div>
        );
      },
    },
    {
      id: 'nationality',
      title: 'Nationality',
      render: row => {
        const country = countryList.find(c => c.countryId === row.countryIdSeller);
        const flagUrl = `/images/flags/${row.buyAnonymous ? 'pirate' : country.countryCode}.png`;
        const countryName = row.sellAnonymous ? '******' : country.countryName;
        return (
          <>
            <img src={flagUrl} alt={countryName} />
            <span style={{ paddingLeft: 4 }}>{countryName}</span>
          </>
        );
      },
    },
    {
      id: 'hostCountry',
      title: 'Host Country',
      render: row => {
        const country = countryList.find(c => c.countryId === row.countryIdBuyer);
        const flagUrl = `/images/flags/${row.buyAnonymous ? 'pirate' : country.countryCode}.png`;
        const countryName = row.buyAnonymous ? '******' : country.countryName;
        return (
          <>
            <img src={flagUrl} alt={countryName} />
            <span style={{ paddingLeft: 4 }}>{countryName}</span>
          </>
        );
      },
    },
    {
      id: 'numberOfPeopleAvailable',
      title: 'Number Of People Available',
      render: row => row.quantity.toFixed(0),
    },
    {
      id: 'numberOfPeopleMigrated',
      title: 'Number Of People Migrated',
      render: row => row.responseQuantity.toFixed(0),
    },
    {
      id: 'wagePerLaborer',
      title: 'Wage Per Laborer',
      render: row => row.unitPrice.toFixed(2),
    },
    {
      id: 'totalWages',
      title: 'Total Wages',
      render: row => row.price.toFixed(2),
    },
  ];

  return columns;
};

export const History = () => {
  const params = useParams();
  const { setSelectedResourceId } = useSimulationContext();
  const [migrations, setMigrations] = useState([]);

  const MIGRATION_TABLE_COLUMNS = useMemo(
    () => getMigrationTableColumns(setSelectedResourceId),
    [setSelectedResourceId],
  );

  const loadData = async () => {
    let data = await ApiService.retrieveSimulationCountry(params.simulationCountryId);
    data = await ApiService.retrieveSimulationTradeList(data.result.simulationId, {
      migratable: true,
      tradable: false,
    });
    data = data.resultList ?? [];
    data.forEach((item, index) => (item.id = index));
    setMigrations(data);
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Table size="small" pagination={false} rowKey="id" columns={MIGRATION_TABLE_COLUMNS} dataSource={migrations} />
    </>
  );
};
